import { ReactElement } from 'react'
import Delete from '@mui/icons-material/Delete'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import { useElementLabel } from '@editorHooks'

const fmt2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

interface Props {
  selectedTargetGuid: string
  targets: ElementSupportItem[]
  allowDelete?: boolean
  onClickTarget: (targetGuid: string) => void
  onClickDelete: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    targetGuid: string,
  ) => void
}

const VerticalTransmitterTargetList = ({
  selectedTargetGuid,
  targets,
  allowDelete = true,
  onClickTarget,
  onClickDelete,
}: Props): ReactElement => {
  const getLabel = useElementLabel()

  return (
    <>
      <Stack direction={'column'} spacing={0.5} alignItems="left">
        {targets.map(({ guid, element_guid, transmission_factor }) => {
          const targetElementLabel = getLabel(element_guid)
          const transmissionFactorFormatted = fmt2.format(transmission_factor)
          const showTransmissionFactor = transmission_factor !== 1
          return (
            <Box
              key={guid}
              border={1}
              borderColor="grey.200"
              bgcolor={selectedTargetGuid === guid ? 'grey.200' : 'transparent'}
              borderRadius={1}
              paddingX={0.5}
              onClick={() => onClickTarget(guid)}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography fontSize="small">{targetElementLabel}</Typography>
                {showTransmissionFactor && (
                  <Typography fontSize="small">{`a=${transmissionFactorFormatted}`}</Typography>
                )}
                {allowDelete && (
                  <IconButton
                    onClick={event => onClickDelete(event, guid)}
                    data-cy="btn-delete-vertical-transmitter"
                    size="small"
                    sx={{ paddingX: 0 }}
                  >
                    <Delete fontSize="inherit" />
                  </IconButton>
                )}
              </Stack>
            </Box>
          )
        })}
      </Stack>
    </>
  )
}

export default VerticalTransmitterTargetList
